var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".home_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13.5v9a1 1 0 0 0 1 1H9a.5.5 0 0 0 .5-.5v-4a2.5 2.5 0 0 1 5 0v4a.5.5 0 0 0 .5.5h4.5a1 1 0 0 0 1-1V14M.5 13 12 1.5 23.5 13M16 2.5h3a.5.5 0 0 1 .5.5v3",
    className: "home_svg__a"
  })));
};
export default SvgHome;